// extracted by mini-css-extract-plugin
module.exports = {"main":"SignDiv_main__Ns27X","hidden":"SignDiv_hidden__1Mr9T","nonActive":"SignDiv_nonActive__2kOvn"};